import { CSSProperties } from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import { useReactFlow } from '@xyflow/react';

interface DragItem {
  preview?: () => JSX.Element;
}

const layerStyle: CSSProperties = {
  position: 'fixed',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 99999,
};

function getItemStyles(offset: XYCoord | null): CSSProperties {
  if (!offset) return { display: 'none' };

  const { x, y } = offset;
  const transform = `translate(${x}px, ${y}px)`;

  return { transform, WebkitTransform: transform };
}

export default function CustomDragLayer() {
  const { item, isDragging, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem() as DragItem,
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));
const { getZoom } = useReactFlow();
const zoom = getZoom();
  if (!isDragging || !item?.preview) return null;

  return (
    <div style={layerStyle}>
      <div style={getItemStyles(currentOffset)}>
        {/* Ghost copy */}
        <div style={{ opacity: 0.7, transform: `scale(${zoom})`, transformOrigin: 'top left' }}>
          {item.preview()}
        </div>
      </div>
    </div>
  );
}
